import { render, staticRenderFns } from "./Insight_Rating.vue?vue&type=template&id=20aa8028&scoped=true"
import script from "./Insight_Rating.vue?vue&type=script&lang=js"
export * from "./Insight_Rating.vue?vue&type=script&lang=js"
import style0 from "./Insight_Rating.vue?vue&type=style&index=0&id=20aa8028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa8028",
  null
  
)

export default component.exports